/**
 * Direction-aware geometry for positioned overlays (ENG-387).
 *
 * A fixed-position dropdown anchored with `right: viewport - rect.right`
 * follows the *physical* right edge, so under `dir="rtl"` — where the trigger
 * sits at the far left — the menu opens off-screen. These helpers turn a
 * trigger's `getBoundingClientRect()` into the offset for the *logical*
 * `inset-inline-start` / `inset-inline-end` properties instead, so the
 * component's JSX never carries `left` / `right` (which the RTL gate in
 * `src/test/rtlGuards.js` rejects on RTL-ready components).
 *
 *   dir='ltr'  inline-start = left,  inline-end = right
 *   dir='rtl'  inline-start = right, inline-end = left
 */

/** Distance from the viewport's inline-start edge to the anchor's inline-start edge. */
export const inlineStartOffset = (dir, rect, viewportWidth) =>
  dir === 'rtl' ? viewportWidth - rect.right : rect.left;

/** Distance from the viewport's inline-end edge to the anchor's inline-end edge. */
export const inlineEndOffset = (dir, rect, viewportWidth) =>
  dir === 'rtl' ? rect.left : viewportWidth - rect.right;
